<template>
  <div>
    <div ref="inputWrapper" class='uploadImgWrapper' @click='uploadClick'></div>
<!--    <input class="uploadImgWrapper" type="file" @change="upload" />-->
<!--    <input id="uploaderInput" style="display: none" type="file" capture="camera" @change="upload"/>-->
    <img class="uploadImg" v-if="url" :src="url" />
    <div class="loadingBox" v-if="loading">
      <img class="loading" src="../../assets/loading.gif" />
    </div>
  </div>
</template>

<script>
import { uploadFile } from "@/api/upload";
import { compress } from "./compressor";

export default {
  name: "uploadImg",
  props: ["value"],
  watch: {
    value(e) {
      this.url = e;
    }
  },
  data() {
    return {
      url: "",
      loading: false,
      hasAuth:false
    };
  },
  methods: {
    uploadClick(){
      let that=this
      if(this.hasAuth){
        // document.getElementById('uploaderInput').click();
        this.getDom()
      }
      else {
        // let result = confirm("授权提示：我们需要访问您的相机、相册或者本地文件");
        let result = confirm("授权提示：我们需要访问您的相机");
        if (result) {
          this.hasAuth=true
          // document.getElementById('uploaderInput').click();
          that.getDom()
        }
      }
    },
    getDom() {
      let that=this
      this.$nextTick(() =>{
        let input =document.createElement('input')
        input.type='file'
        input.capture='camera'
        input.style='width:100%;height:100%;opacity:0;display:block'
        input.setAttribute('ref','myRef')
        input.setAttribute('class','myInput')
        input.onchange=(event)=>{
          const formData = new FormData()
          let myFile=event.srcElement.files[0]

          if(myFile.size/(1024*1024)>20){
            that.$showError('文件过大！')
          }
          else {
            formData.append('file', myFile)
            uploadFile(formData).then(res=>{
              myFile = ''
              that.$emit('input', res.link)
            }).catch(err=>{
              that.$showError(err)
            })
          }
        }
        this.$refs.inputWrapper.appendChild(input)
      })

    },
    upload(e) {
      let that = this;
      this.$vux.loading.show();
      compress(e.target.files[0])
        .then(res => {
          const { file } = res;
          const form = new FormData();
          form.append("file", file);
          if (file) {
            uploadFile(form)
              .then(res => {
                that.url = res.link;
                // that.$emit("input", res.link);
                that.$emit("getUrl", res.link);
                this.$vux.loading.hide();
              })
              .catch(err => {
                this.$vux.loading.hide();
                this.$showError(err);
              });
          }
        })
        .catch(err => {
          this.$vux.loading.hide();
          this.$showError(err);
        });
    }
  }
};
</script>

<style scoped>
.uploadImgWrapper {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.uploadImg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
}
.loadingBox {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  width: 100%;
  height: 100%;
  background: #fff;
}
.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 3;
  width: 60px;
  height: 60px;
  margin-left: -30px;
  margin-top: -30px;
}
</style>
